


























































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import Tools from '../../../../../lib/tools';
import QuickTable from "../../../../../components/table/table.vue";
import SelectPerson from "../../../../../components/select/selectPerson.vue";
import SelectDep from "../../../../../components/select/selectDep.vue";
@Component({
	name:'emergencyReservePlan',
	components: {
		QuickTable,
		SelectPerson,
		SelectDep
	}
})
export default class EmergencyReservePlan extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		formData: {
			id: '',
			belongDepId: '',
			reservePlanName: '',
			publishDt: '',
			keepOnRecordDep: '',
			reviseDt: '',
			reviseContent: '',
			depLeaderId: '',
			remark: ''
		},
		validate: {
			reservePlanName: [
				{ required: true, message: '请填写应急预案名称', trigger: 'blur' }
			],
			belongDepId: [
				{ required: true, type: 'number', message: '请选择所属部门', trigger: 'change' }
			],
			depLeaderId: [
				{ required: true, type: 'number', message: '请选择部门负责人', trigger: 'change' }
			]
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '部门',
				key: 'belongDep',
				render: (h:any, params:any) => {
					return h('span', params.row.belongDep ? params.row.belongDep.displayName : '');
				}
			},
			{
				title: '应急预案名称',
				key: 'reservePlanName'
			},
			{
				title: '发布时间',
				key: 'publishDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.publishDt));
				}
			},
			{
				title: '备案单位',
				key: 'keepOnRecordDep'
			},
			{
				title: '修订时间',
				key: 'reviseDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.reviseDt));
				}
			},
			{
				title: '修订主要内容',
				key: 'reviseContent'
			},
			{
				title: '部门负责人',
				key: 'depLeader',
				render: (h:any, params:any) => {
					return h('span', params.row.depLeader ? params.row.depLeader.name : '');
				}
			},
			{
				title: '备注',
				key: 'remark'
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = params.row[k];
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'reviseDt') {
							params[k] = Tools.formatDate(datas[k]);
						}else{
							params[k] = datas[k];
						}
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/EmergencyRescue/UpdateReservePlanAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/EmergencyRescue/CreateReservePlanAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此应急救援预案？',
            onOk: () => {
                Ajax.delete('/api/services/app/EmergencyRescue/DeleteReservePlanAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
}
